export const CLASSIC_SETTINGS_BASE_PATH = '/settings'
export const V2_SETTINGS_BASE_PATH = '/v2/settings'

export const SETTINGS_PAGES = {
  account: 'account',
  organization: 'organization',
  llm: 'llm',
  theme: 'theme',
  language: 'language',
} as const

export type SettingsPage = keyof typeof SETTINGS_PAGES

export function getSettingsBasePath(pathname: string): string {
  if (pathname === '/v2' || pathname.startsWith('/v2/')) {
    return V2_SETTINGS_BASE_PATH
  }
  return CLASSIC_SETTINGS_BASE_PATH
}

export function getSettingsPagePath(
  pathname: string,
  page: SettingsPage
): string {
  return `${getSettingsBasePath(pathname)}/${SETTINGS_PAGES[page]}`
}

export function isV2SettingsShell(pathname: string): boolean {
  return getSettingsBasePath(pathname) === V2_SETTINGS_BASE_PATH
}
